import React from "react";
import Link from "next/link";
import { Grid } from "@mui/material";
import styles from "./highlights.module.scss";
import { ReactSVG } from "react-svg";
import { getAssets } from "@unisearch/helpers";

export const ElearningLeadHighlights = () => {
  return (
    <section className={styles.section_onlinetest}>
      <div className="container">
        <h2 className={styles.title}>
          Program <span className={"color-orange"}>Highlights</span>
        </h2>

        <Grid container spacing={{ xs: 3, sm: 3, md: 4 }}>
          <Grid item xs={12} sm={6} md={3}>
            <div className={`${styles.test_card} ${styles.test_card_1}`}>
              <ReactSVG
                className={styles.test_icon}
                src={getAssets("assets/images/elearning/training.svg")}
              />
              <h4 className={styles.test_title}>
                Certified IELTS Trainer with Proven Success Rate
              </h4>
              <div className={styles.test_desc}>
                Get the insider insight you need to score better in IELTS
                Speaking, from trainers with years of experience coaching
                students to achieve their dream scores
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <div className={`${styles.test_card} ${styles.test_card_2}`}>
              <ReactSVG
                className={styles.test_icon}
                src={getAssets("assets/images/elearning/desk-chair.svg")}
              />
              <h4 className={styles.test_title}>Limited Seats</h4>
              <div className={styles.test_desc}>
                Giving each student the attention and support they need is
                UniSearch’s top priority - we stick to smaller batches to
                ensure every individual receives personalized guidance
              </div>
            </div>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <div className={`${styles.test_card} ${styles.test_card_3}`}>
              <ReactSVG
                className={styles.test_icon}
                src={getAssets("assets/images/elearning/money.svg")}
              />
              <h4 className={styles.test_title}>No Registration Fee</h4>
              <div className={styles.test_desc}>
                Giving each student the attention and support they need is
                UniSearch’s top priority - we stick to smaller batches to
                ensure every individual receives personalized guidance
              </div>
            </div>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <div className={`${styles.test_card} ${styles.test_card_4}`}>
              <ReactSVG
                className={styles.test_icon}
                src={getAssets("assets/images/elearning/diamond.svg")}
              />
              <h4 className={styles.test_title}>
                Exclusively Official Content
              </h4>
              <div className={styles.test_desc}>
                Our trainers exclusively use study materials designed by the
                official test administrators to give you real experience in how
                to ace the actual exam
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default ElearningLeadHighlights;
